import Vue from "vue";

export async function index() {
    const response = await Vue.prototype.$http.get('budget_objectives');

    return response.data;
}